module.exports = __webpack_public_path__ + "static/img/banner5ls.cc6fa8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner5ls.jpg
// module id = 1VTB
// module chunks = 0